export default "__VITE_ASSET__e263adfd__"